import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ChannelPlanExceededMixin extends Vue {
  public channelPlanExceeded = 0;

  public usersLimitExceeded = false;

  public usersLimitReached = false;

  get hasChannelPlanExceeded(): boolean {
    return this.channelPlanExceeded > 0;
  }

  get hasUsersLimitExceeded(): boolean {
    return this.usersLimitExceeded;
  }

  get hasUsersLimitReached(): boolean {
    return this.usersLimitReached;
  }

  public async fetchGeneralConsumption(): Promise<void> {
    try {
      const { data } = await this.$http.get(process.env.VUE_APP_GENERAL_CONSUMPTION);
      this.channelPlanExceeded = data?.channelPlan?.exceeded || 0;
      this.usersLimitReached = data?.softwarePlan?.users?.limit === data?.softwarePlan?.users?.totalSpent;
      this.usersLimitExceeded = data?.softwarePlan?.users?.exceeded !== 0;
    } catch (error) {
      this.channelPlanExceeded = 0;
    }
  }
}
